import React from 'react';
import {
    Container,
    Text,
    className,
    Row,
    Col,
    Heading,
    ImageComponent,
} from 'aplazame-design-system';
import TransitionLink from 'aplazame-design-system/src/components/TransitionLink';
import style from './styles.module.scss';
import textStyle from 'aplazame-design-system/src/scss/text.module.scss';

export default function PluginsSection(props) {
    return (
        <section {...className(`${props.newStyle ? style.newStyle : ""} ${props.colorScheme === "Dark" ? style.black : ""}`)}>
            <Container {...className(`${!props.newStyle ? 'mt-15 mb-10' : ''} `)}>
                <Row>
                    <Col
                        col={{
                            lg: 6,
                        }}
                    >
                        <Heading
                            className={`h2 ${textStyle.gradual} ${style.heading}`}
                            tag="h2"
                            data-sal="slide-up"
                            data-sal-easing="ease-out-quart"
                        >
                            {props.title || ''}
                        </Heading>
                        <Text
                            mt={{ xs: 5 }}
                            mb={{ xs: 10 }}
                            className={`h3 ${style.text}`}
                            tag="p"
                            data-sal="slide-up"
                            data-sal-easing="ease-out-quart"
                        >
                            {props.description || ''}
                        </Text>
                    </Col>
                </Row>
                <Row>
                    {props.plugins.map((res, index) => (
                        <Col
                            key={index}
                            col={{
                                lg: 4,
                            }}
                            mb={{
                                xs: 5,
                            }}
                            data-sal="slide-up"
                            data-sal-easing="ease-out-quart"
                            data-sal-delay={`xs-none--lg-${(index % 3) * 100}`}
                        >
                            <TransitionLink
                                key={index}
                                to={res.slug}
                                {...className(
                                    `d-flex align-items-center justify-content-center flex-column p-5 ${style.pluginItem}`
                                )}
                            >
                                <ImageComponent alt={props.colorScheme === "Dark" ? res.logoLight.alt : res.logo.alt} image={props.colorScheme === "Dark" ? res.logoLight : res.logo} />
                                {res.version && (
                                    <Text className={style.version} mt={{ xs: 1 }}>{res.version}</Text>
                                )}
                            </TransitionLink>
                        </Col>
                    ))}
                </Row>
            </Container>
        </section>
    );
}
